import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

export const COMMENTS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/comments/views/comments/comments.component').then((m) => m.CommentsComponent),
        data: { routePath: RoutePath.COMMENTS },
    },
];
